import { Star, Quote } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

const Testimonials = ({ testimonials, loading }) => {
  if (loading) {
    return (
      <section id="testimonials" className="py-16 md:py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-16">
            <Skeleton className="h-8 w-32 mb-4" />
            <Skeleton className="h-12 w-80 mb-4" />
          </div>
          <div className="grid md:grid-cols-3 gap-6">
            {[1, 2, 3].map((i) => (
              <Skeleton key={i} className="h-64 rounded-2xl" />
            ))}
          </div>
        </div>
      </section>
    );
  }

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-16 md:py-24 bg-gradient-to-b from-blue-50 to-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="mb-16">
          <span className="text-[#2563EB] font-medium text-sm uppercase tracking-wider">
            Testimonials
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mt-2 mb-4">
            What Our Clients
            <br />
            <span className="gradient-text">Say About Us</span>
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className={`testimonial-card p-6 rounded-2xl border border-slate-100 shadow-sm relative ${
                index === 0 ? "md:col-span-2" : ""
              }`}
              data-testid={`testimonial-${testimonial.id}`}
            >
              {/* Quote Icon */}
              <div className="absolute top-4 right-4 text-[#2563EB]/20">
                <Quote className="w-10 h-10" strokeWidth={1} />
              </div>

              {/* Stars */}
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star
                    key={i}
                    className="w-5 h-5 fill-amber-400 text-amber-400"
                    strokeWidth={1}
                  />
                ))}
              </div>

              {/* Content */}
              <p className={`text-slate-700 mb-6 ${index === 0 ? "text-lg" : ""}`}>
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-[#2563EB]/10 rounded-full flex items-center justify-center">
                  <span className="text-[#2563EB] font-semibold text-lg">
                    {testimonial.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-slate-900">{testimonial.name}</p>
                  <p className="text-sm text-slate-500">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Trust Badge */}
        <div className="mt-12 text-center">
          <p className="text-slate-500 text-sm">
            Trusted by <span className="font-semibold text-slate-700">500+ families and businesses</span> in River City
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
